import { MspLandingPageWebComponent } from "./component/MspLandingPageWebComponent"

export { MspLandingPageWebComponent }
